import K from "./constants";
import restHelpers from "../helpers/restHelper";

const createMandate = user => restHelpers.withBearer.post(`${K.API_URL}/api/v2/slimpay/createMandate?frameLayout=iframeembedded&imei=default`, { data: user });

export default { createMandate }


// WEBPACK FOOTER //
// ./src/services/slimpay.js